import { render, staticRenderFns } from "./PeriodOfConstructionFormField.vue?vue&type=template&id=6b19431b"
import script from "./PeriodOfConstructionFormField.vue?vue&type=script&lang=js"
export * from "./PeriodOfConstructionFormField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports